import React from "react";
import logo1 from "../images/leeford_logo.png";
import logo2 from "../images/baner3.jpg";

const Header = () => {
  return (
    <div className="flex justify-between items-center px-5 py-2.5 bg-white border-b-2 border-gray-200">
      <div>
        <img
              src={logo1}
              alt="Leeford Logo"
              className="object-contain w-[18vw] max-w-[160px] min-w-[80px] h-[23vh] max-h-[64px] min-h-[36px]"
              draggable="false"
            />
      </div>
      <div>
        {/* Increased size for the right-side image */}
        <img
          src={logo2}
          alt="Banner"
          className="w-[300px] h-auto object-contain"
        />
      </div>
      </div>
  );
};

export default Header;
